import { render, staticRenderFns } from "./campusCen.vue?vue&type=template&id=63983050&scoped=true"
import script from "./campusCen.vue?vue&type=script&lang=js"
export * from "./campusCen.vue?vue&type=script&lang=js"
import style1 from "./campusCen.vue?vue&type=style&index=1&id=63983050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63983050",
  null
  
)

export default component.exports